module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_home1.3dff3.png";